import { isNull } from 'lodash';
import React from 'react';
import { Select } from '@meitu/saas-ui';
import { IMarkupLayerProps, MarkupTextPositionType } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useGlobalWidget } from '@meitu/saas-editor-ui/es/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import IconFont from '@meitu/xdesign-icon-font';
import { getLocaleStore, useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

const { Option } = Select;

const PositionList = () => {
    const { $t } = getLocaleStore();

    return [
        {
            value: MarkupTextPositionType.Up,
            text: $t((v) => v.panel.markupPanel.up),
        },
        {
            value: MarkupTextPositionType.Center,
            text: $t((v) => v.panel.markupPanel.center),
        },
        {
            value: MarkupTextPositionType.Down,
            text: $t((v) => v.panel.markupPanel.down),
        },
    ];
};

export const LabelPosition: React.FC<{
    id: string;
    onAfterChange?: Function;
    trackCode?: string | number;
}> = React.memo(({ id, onAfterChange, trackCode }) => {
    const { $t } = useLocaleStore();

    const res = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { label } = layer.data as IMarkupLayerProps;
        return {
            position: label.position,
        };
    });

    const globalWidgetRef = useGlobalWidget(editor, false);

    if (isNull(res)) return null;

    const { position } = res;

    return (
        <div className="c-markup-panel__item c-markup-label__position">
            <LabelAction title={$t((v) => v.panel.markupPanel.position)} align={true}>
                <div>
                    <Select
                        value={position}
                        suffixIcon={
                            <IconFont name="ChevronDownBlack" fontSize={10} color="var(--content-input-label)" />
                        }
                        popupClassName="c-markup-label__position-select"
                        className="c-markup-panel__dasharray"
                        onChange={(value: MarkupTextPositionType, option: any) => {
                            if (id) {
                                const layer = editor.stage.getLayer(id, true);
                                editor.markupLayer.setAttrOperateOriginData(layer);
                                editor.markupLayer.setLabelPosition(id, value);
                                editor.markupLayer.clearAttrOperateOriginData();
                            }
                            onAfterChange?.(trackCode);
                        }}
                        onDropdownVisibleChange={(e) => {
                            globalWidgetRef.current = e;
                        }}
                    >
                        {PositionList().map((item, index) => {
                            return (
                                <Option key={index} value={item.value}>
                                    <div className="c-markup-panel__dasharray-item c-markup-label__position-item">
                                        {item.text}
                                    </div>
                                </Option>
                            );
                        })}
                    </Select>
                </div>
            </LabelAction>
        </div>
    );
});
